import { useCallback } from 'react';

const useForgotPassword = (brandId) => {
  const checkPhoneStatus = useCallback(async (email) => {
    const response = await fetch('/api/v5/users/mobile_verify/email_status', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        email,
        brand_id: brandId 
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to check phone status');
    }

    return response.json();
  }, [brandId]);

  const sendResetCode = useCallback(async (email) => {
    const response = await fetch('/api/v5/users/mobile_verify/email_verify', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        email,
        brand_id: brandId 
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to send reset code');
    }

    const data = await response.json();
    
    if (!data.success) {
      throw new Error('No verified mobile number found for this account');
    }

    return data;
  }, [brandId]);

  const verifyResetCode = useCallback(async (email, code) => {
    const response = await fetch('/api/v5/users/mobile_verify/email_confirm', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        email, 
        code,
        brand_id: brandId 
      })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to verify code');
    }

    const data = await response.json();
    
    if (data.status === 'code_approved') {
      return { valid: true, password_reset_token: data.password_reset_token };
    } else if (data.status === 'code_expired') {
      throw new Error('Verification code has expired');
    } else {
      throw new Error('Incorrect verification code');
    }
  }, [brandId]);

  const resetPassword = useCallback(async (reset_code, password) => {
    const response = await fetch('/api/v5/users/passwords', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(window.gon?.csrf_token && { 'X-CSRF-Token': window.gon.csrf_token })  
      },
      body: JSON.stringify({
        reset_password_token: reset_code,
        password: password,
      })
  
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to reset password');
    }

    return response.json();
  }, [brandId]);

  return {
    checkPhoneStatus,
    sendResetCode,
    verifyResetCode,
    resetPassword
  };
};

export default useForgotPassword;